export enum ScreenRef {
  INDIVIDUAL_STRUCTURAL_HOROSCOPE = 'INDIVIDUAL_STRUCTURAL_HOROSCOPE',
  LOGIN = 'LOGIN',
  REGISTER = 'REGISTER',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  PROFILE = 'PROFILE',
  DELETE_PROFILE = 'DELETE_PROFILE',
  PERSON = 'PERSON',
  PERSON_HOROSCOPE_SUMMARY = 'PERSON_HOROSCOPE_SUMMARY',
  PEOPLE = 'PEOPLE',
  ANNUAL_SIGN = 'ANNUAL_SIGN',
  DEFAULT = 'DEFAULT',
  LABEL = 'LABEL',
}
